module.exports = __webpack_public_path__ + "media/react/shared/components/true_link/main/apple-store-97a8672f4037b96c98abeb19459a1891.svg";